export const generateTagColors = (array: string[]) => {
  const tagColors = [
    "orange",
    "red",
    "green",
    "cyan",
    "blue",
    "geekblue",
    "purple",
    "magenta",
    "lime",
    "pink",
    "volcano",
  ];

  const tagColorsMap: Record<string, string> = {};

  array.forEach((template, index) => {
    tagColorsMap[template] = tagColors[index % tagColors.length];
  });

  return tagColorsMap;
};
